import getLinkToDetail from 'helpers/getLinkToDetail'
import getTitle from 'helpers/getTitle'
import Translate from 'modules/local/Translate'
import React from 'react'
import {Link} from 'react-router-dom'
import {NullAsDefault} from 'views/Shared'
import _ from "lodash";
import {renderIf} from "../../Shared";
import {ItemInformation} from 'components/common/ItemInformation'
import {formatDate} from "../../../helpers/datetimeHelpers";
import {DoubleValueItem} from 'components/common/DoubleValueItem'
import {formatSimplifyDate} from "../../../helpers/dateUtils";
import {GoDotFill} from "react-icons/go";


export const renderExamination = ({translate: t, renderContextMenu = NullAsDefault} = {}) => (item, index) => {
    const {
        description,
        categories = [],
        postscript,
        timelimit,
        time_open,
        time_close,
    } = item ?? {}

    return (
        <div key={index} className="p-4 custom-item-render transition-all duration-300 relative list-item">
            <Link
                to={getLinkToDetail(item)}
                className="font-bold text-lg text-color-000 no-underline">
                {getTitle(item)}
            </Link>
            {renderIf(
                description,
                <div className="text-color-300 tracking-wider">
                    {description}
                </div>
            )}
            {renderIf(
                postscript,
                <div className="mt-1 p-2 bg-blue-100 rounded-xl space-x-1 tracking-wider">
                    <span className="font-semibold text-blue-600">
                        {`* ${t('note')}: `}
                    </span>
                    <span className="text-color-300 italic">
                        {postscript}
                    </span>
                </div>
            )}
            <div className="mt-3 mb-2 border-b border-color-50"/>
            <div className="space-x-1 italic tracking-wider">
                <GoDotFill size={10} className="text-color-500"/>
                <span className="text-color-400">
                    {`${t('time takes place')}: `}
                </span>
                <span className="font-semibold text-color-100 capitalize">
                    {formatSimplifyDate(time_open, 'fullTime')}
                </span>
                {time_close && (
                    <span className="font-semibold text-color-100 capitalize">
                        {` - ${formatSimplifyDate(time_close, 'fullTime')}`}
                    </span>
                )}
            </div>
            <ItemInformation
                showIcon={true}
                label={t('time for work')}
                value={`${timelimit} ${t('minutes')}`}
                className="italic tracking-wider"
            />
            <div className="absolute right-8 top-8 contextIcon">
                {renderContextMenu(item)}
            </div>
        </div>
    )
}


export const renderExaminationCompact =
    ({renderContextMenu = NullAsDefault} = {}) =>
        (item, index) => {
            const {time_open, time_close, owner} = item ?? {}

            return (
                <Translate key={index}>
                    {(t) => (
                        <div className="px-3 py-2 background border border-color-50 shadow-md hover:scale-2xs rounded-xl custom-item-render relative">
                            <div className="flex flex-col">
                                <Link
                                    to={getLinkToDetail(item)}
                                    className="mb-1 font-bold text-base text-color-000 no-underline leading-tight truncate">
                                    {getTitle(item)}
                                </Link>

                                <ItemInformation
                                    showIcon={true} label="organization by"
                                    className="text-xs italic truncate"
                                    value={
                                        <Link to={getLinkToDetail(owner)}
                                              className="flex-1 font-medium text-blue-500 no-underline">
                                            {getTitle(owner)}
                                        </Link>
                                    }
                                />
                                {renderIf(
                                    _.some([time_open, time_close]),
                                    <DoubleValueItem
                                        showIcon={true}
                                        labelFirst="from date"
                                        valueFirst={formatDate(time_open, 'DD/MM/YYYY')}
                                        labelSecond={time_close && ' - ' || ''}
                                        valueSecond={time_close && formatDate(time_close, 'DD/MM/YYYY')}
                                        className="text-xs italic truncate" // Tăng text-xs -> text-sm
                                    />
                                )}
                            </div>
                            {_.isFunction(renderContextMenu) && (
                                <div className="absolute right-5 top-5 contextIcon">
                                    {renderContextMenu(item)}
                                </div>
                            )}
                        </div>
                    )}
                </Translate>
            )
        }